// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"0b8f4460","309":"4e837b5e","810":"949cf051","812":"73570a15","950":"9df2060d","961":"380a5453"}[chunkId] + ".chunk.css";
};